import React, { useState } from 'react'
import NewButton from '../../../../NewComponents/NewButton';
import LOGO from "../../../../assets/logo.png";


const QuestionComponent = ({windowSize, children,question, onContinue, progressTitle, progress, backBTnText, onBack = () => {},
 subQuestion, subQuestionIcon, subText, subTextIcon, showInput, inputValue, setInputValue, disableContinue, onContinueBtnText = "Continue"}) => {

  return (
    <div className='flex flex-col justify-start items-start flex-1 px-[40px] py-[20px] gap-4'>
    <img
          src={LOGO}
          alt="Logo eVerbary"
          className="h-10 w-auto cursor-pointer"
        />
      <div className='w-full'>
        <h2 className='questionsProgressTitle'>{progressTitle}</h2>
        <div className='flex gap-2 w-full mt-2'>
          <div className={`flex-[1] ${progress >= 0 ? 'bg-[#12ABBF]' : 'bg-[#E6E7E9]'} w-full h-[3px] rounded-[8px]`}></div>
          <div className={`flex-[1] ${progress >= 1 ? 'bg-[#12ABBF]' : 'bg-[#E6E7E9]'} w-full h-[3px] rounded-[8px]`}></div>
          <div className={`flex-[1] ${progress >=2 ? 'bg-[#12ABBF]' : 'bg-[#E6E7E9]'} w-full h-[3px] rounded-[8px]`}></div>
          <div className={`flex-[1] ${progress >= 3 ? 'bg-[#12ABBF]' : 'bg-[#E6E7E9]'} w-full h-[3px] rounded-[8px]`}></div>
         
        </div>
      </div>

      <div className='w-full flex-[1] flex flex-col justify-center items-start gap-[24px]'>
        <div className='flex flex-col gap-[8px]'>
            <h2 className='questionsProgressTitle'>{question}</h2>
            {subQuestion && <div className='flex gap-[8px] items-start justify-start'>
            {subQuestionIcon && subQuestionIcon}
            <p className='questionsSubText'>
                {subQuestion}
            </p>
            </div>}
        </div>
        {children}

        {showInput && <div className='flex gap-[8px] items-start justify-start'>
          <input autoFocus={true} 
          className='onBoarding-description w-full max-w-[450px] border-[1px] border-[#E6E7E9] rounded-[8px] px-[16px] py-[16px] outline-none
          focus:border-[#12ABBF]' 
          type="text" placeholder="Enter platform name" value={inputValue} onChange={(e) => setInputValue(e.target.value)}/>
        </div>}

        {subText && <div className='flex gap-[8px] items-start justify-start'>
          {subTextIcon && subTextIcon}
           <p className='questionsSubText max-w-[450px]'>
            {subText}
          </p>
        </div>}
      </div>

      <div className={`w-full flex ${backBTnText ? 'justify-between' : 'justify-end'} items-center gap-2 flex-wrap max-sm:justify-end`}>
        {backBTnText && <NewButton width={windowSize.width > 568 ? '240px' : '100%'} text={backBTnText} icon={false} onClick={onBack} whiteBtn={true} back={true}/>}
        {onContinue && <NewButton width={windowSize.width > 568 ? '240px' : '100%'} text={onContinueBtnText} icon={false} onClick={onContinue} disabled={disableContinue}/>}
      </div>

    </div>
  )
}

export default QuestionComponent